<template>
  <!-- <CRow> -->
  <CButtonGroup>
    <CButton class="px-1 b-background" @click="arrowLeft()" :color="errorColor"
      ><CIcon name="cil-caret-left"
    /></CButton>
    <!-- <CButton
                      class="btn-header"
                      variant="outline"
                      @click="toggleMonth()"
                      color="primary"
                      >AG 2020</CButton
                    > -->
    <div class="b-background" :class="`bg-${errorColor}`">
      <CDropdown
        placement="bottom-start"
        :toggler-text="formatText"
        :color="errorColor"
        :show.sync="dropdownCustom"
      >
        <CDropdownHeader v-if="isSmall" class="dropdown-sp ">
          <div class="d-flex flex-wrap justify-content-center">
            <CButton
              class="btn-header px-2 mr-1 w-100"
              @click="toggleWeek()"
              color="primary"
              >Semana</CButton
            >

            <CButton
              class="btn-header px-2 w-100"
              @click="toggleMonth()"
              color="primary"
              >Mes</CButton
            >

            <CButton
              class="btn-header px-2  mr-1 w-100"
              @click="toggleYear()"
              color="primary"
              >Año</CButton
            >

            <CButton
              class="btn-header px-2 w-100"
              @click="toggleLastWeek()"
              color="primary"
              >Semana Anterior</CButton
            >

            <CButton
              class="btn-header px-2  mr-1 w-100"
              @click="toggleLastMonth()"
              color="primary"
              >Mes Anterior</CButton
            >

            <CButton
              class="btn-header px-2 w-100"
              @click="toggleLastYear()"
              color="primary"
              >Año Anterior</CButton
            >

            <CButton
              class="btn-header px-2  mr-1 w-100"
              @click="toggleLastSevenDays()"
              color="primary"
              >Ultimos 7 Días</CButton
            >

            <CButton
              class="btn-header px-2 w-100"
              @click="toggleLastThirtyDays()"
              color="primary"
              >Ultimos 30 Días</CButton
            >

            <CButton
              class="btn-header px-2  mr-1 w-100"
              @click="toggleLastNinetyDays()"
              color="primary"
              >Ultimos 90 Días</CButton
            >

            <CButton
              class="btn-header px-2 w-100"
              @click="customOpenDateSelector()"
              color="primary"
              >Perzonalizado</CButton
            >
          </div>

          <div
            v-if="this.isCustomOpen"
            class="w-100 d-flex align-items-center justify-content-center"
          >
            <v-date-picker
              mode="range"
              v-model="selectedDate"
              @input="onChangeDate(`days`)"
              is-inline
              is-expanded
              :first-day-of-week="2"
              show-caps
              color="indigo"
            />
          </div>
        </CDropdownHeader>
        <CDropdownHeader v-else class="dropdown-sp">
          <CRow class="margin-container">
            <CCol class="px-1 container-button" sm="4">
              <CButton
                class="btn-header px-2 w-100"
                @click="toggleWeek()"
                color="primary"
                >Semana</CButton
              >
            </CCol>
            <CCol class="px-1 container-button" sm="4">
              <CButton
                class="btn-header px-2 w-100"
                @click="toggleMonth()"
                color="primary"
                >Mes</CButton
              >
            </CCol>
            <CCol class="px-1 container-button" sm="4">
              <CButton
                class="btn-header px-2 w-100"
                @click="toggleYear()"
                color="primary"
                >Año</CButton
              >
            </CCol>
          </CRow>
          <CRow class="margin-container">
            <CCol class="px-1 container-button" sm="4">
              <CButton
                class="btn-header px-2 w-100"
                @click="toggleLastWeek()"
                color="primary"
                >Semana Anterior</CButton
              >
            </CCol>
            <CCol class="px-1 container-button" sm="4">
              <CButton
                class="btn-header px-2 w-100"
                @click="toggleLastMonth()"
                color="primary"
                >Mes Anterior</CButton
              >
            </CCol>
            <CCol class="px-1 container-button" sm="4">
              <CButton
                class="btn-header px-2 w-100"
                @click="toggleLastYear()"
                color="primary"
                >Año Anterior</CButton
              >
            </CCol>
          </CRow>
          <CRow class="margin-container">
            <CCol class="px-1 container-button" sm="4">
              <CButton
                class="btn-header px-2 w-100"
                @click="toggleLastSevenDays()"
                color="primary"
                >Ultimos 7 Días</CButton
              >
            </CCol>
            <CCol class="px-1 container-button" sm="4">
              <CButton
                class="btn-header px-2 w-100"
                @click="toggleLastThirtyDays()"
                color="primary"
                >Ultimos 30 Días</CButton
              >
            </CCol>
            <CCol class="px-1 container-button" sm="4">
              <CButton
                class="btn-header px-2 w-100"
                @click="toggleLastNinetyDays()"
                color="primary"
                >Ultimos 90 Días</CButton
              >
            </CCol>
          </CRow>
          <CRow class="margin-container">
            <CCol class="px-1 container-button" sm="12">
              <CButton
                class="btn-header px-2 w-100"
                @click="customOpenDateSelector()"
                color="primary"
                >Perzonalizado</CButton
              >
            </CCol>
          </CRow>
          <div
            v-if="this.isCustomOpen"
            class="w-100 d-flex align-items-center justify-content-center"
          >
            <v-date-picker
              mode="range"
              v-model="selectedDate"
              @input="onChangeDate(`days`)"
              is-inline
              is-expanded
              :first-day-of-week="2"
              show-caps
              color="indigo"
            />
          </div>
        </CDropdownHeader>
      </CDropdown>
    </div>
    <CButton class=" px-1 b-background" @click="arrowRight()" :color="errorColor"
      ><CIcon name="cil-caret-right"
    /></CButton>
  </CButtonGroup>
  <!-- </CRow> -->
</template>

<script>
import { setupCalendar, DatePicker } from "v-calendar";
// import "v-calendar/lib/v-calendar.min.css";
import moment from "moment";

setupCalendar({
  firstDayOfWeek: 2 // Monday
});

// const today = new Date();

export default {
  name: "DateSelector",
  components: {
    "v-date-picker": DatePicker
  },
  props: {
    isValid: {
      type: Boolean,
      default: null
    },
    initDates: {
      type: String
    },
    date: {
      type: Object
    }
  },
  data() {
    return {
      unit: "days",
      dropdownCustom: false,
      isCustomOpen: false,
      size: window.innerWidth,
      selectedDate: {
        start:
          this.initDates == "week"
            ? moment()
                .startOf("isoWeek")
                .toDate()
            : moment()
                .startOf("month")
                .toDate(),

        end:
          this.initDates == "week"
            ? moment()
                .endOf("isoWeek")
                .toDate()
            : moment()
                .endOf("month")
                .toDate()
        // end: new Date(2020, 2, 11)
      }
    };
  },
  created() {
    this.date
      ? ((this.selectedDate.start = this.date.start),
        (this.selectedDate.end = this.date.end))
      : null;
    window.addEventListener("resize", this.myEventHandler);
    this.onChangeDate("days");
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  computed: {
    error(){
      if(this.isValid!==null){
        return !this.isValid
      } else {
        return false
      }
    },
    errorColor(){
      return this.error ? 'danger' : 'primary';
    },
    rangeStart() {
      return new Date(this.selectedDate.start).toLocaleDateString();
    },
    rangeEnd() {
      return new Date(this.selectedDate.end).toLocaleDateString();
    },
    formatText() {
      const first = moment(this.selectedDate?.start);
      const last = moment(this.selectedDate?.end);
      // if (this.selectedDate.start)
      if (this.unit == "days") {
        const monthFirst = first.format("M");
        const monthLast = last.format("M");

        if (first.format("YYYY") !== last.format("YYYY")) {
          return `${first.format("D")} ${first
            .locale("es-es")
            .format("MMM")
            .toUpperCase()
            .replace(".", "")} ${first.format("YYYY")} - ${last.format(
            "D"
          )} ${last
            .locale("es-es")
            .format("MMM")
            .toUpperCase()
            .replace(".", "")} ${last.format("YYYY")}`;
        }
        if (monthFirst !== monthLast) {
          return `${first.format("D")} ${first
            .locale("es-es")
            .format("MMM")
            .toUpperCase()
            .replace(".", "")} - ${last.format("D")} ${last
            .locale("es-es")
            .format("MMM")
            .toUpperCase()
            .replace(".", "")} ${first.format("YYYY")}`;
        }
        if (first.format("D") !== last.format("D")) {
          return `${first.format("D")} - ${last.format("D")} ${last
            .locale("es-es")
            .format("MMM")
            .toUpperCase()
            .replace(".", "")} ${first.format("YYYY")}`;
        }
        return `${first.format("D")} ${first
          .locale("es-es")
          .format("MMM")
          .toUpperCase()
          .replace(".", "")} ${first.format("YYYY")}`;
      }
      if (this.unit === "months") {
        return `${first
          .locale("es-es")
          .format("MMM")
          .toUpperCase()
          .replace(".", "")} ${first.format("YYYY")}`;
      }
      if (this.unit === "years") {
        return `${first.format("YYYY")}`;
      }

      return "hola";
    },
    isSmall() {
      if (this.size) {
        if (this.size <= 580) {
          return true;
        }
      }
      return false;
    }
  },

  methods: {
    myEventHandler() {
      this.size = window.innerWidth;
      // console.log(e);
    },
    arrowLeft() {
      if (this.unit == "months") {
        this.selectedDate.start = moment(this.selectedDate.start)
          .subtract(1, this.unit)
          .toDate();
        this.selectedDate.end = moment(this.selectedDate.end)
          .subtract(1, this.unit)
          .toDate();
        let fechaFin = new Date((this.selectedDate.end).getFullYear(), (this.selectedDate.end).getMonth() + 1, 0);
        this.selectedDate.end = fechaFin
      } else if(this.unit == "years"){
        this.selectedDate.start = moment(this.selectedDate.start)
          .subtract(1, this.unit)
          .toDate();
        this.selectedDate.end = moment(this.selectedDate.end)
          .subtract(1, this.unit)
          .toDate();
      } else {
        this.selectedDate.start = moment(this.selectedDate.start)
          .subtract(1, this.unit)
          .toDate();
      }
      this.onChangeDate(this.unit);
    },

    arrowRight() {
      if (this.unit == "months") {
        this.selectedDate.start = moment(this.selectedDate.start)
          .add(1, this.unit)
          .toDate();
        this.selectedDate.end = moment(this.selectedDate.end)
          .add(1, this.unit)
          .toDate();
        let fechaFin = new Date((this.selectedDate.end).getFullYear(), (this.selectedDate.end).getMonth() + 1, 0);
        this.selectedDate.end = fechaFin
      } else if(this.unit == "years"){
        this.selectedDate.start = moment(this.selectedDate.start)
          .add(1, this.unit)
          .toDate();
        this.selectedDate.end = moment(this.selectedDate.end)
          .add(1, this.unit)
          .toDate();
      } else {
        this.selectedDate.end = moment(this.selectedDate.end)
          .add(1, this.unit)
          .toDate();
      }
      this.onChangeDate(this.unit);
    },

    onChangeDate(unit) {
      this.$emit("input", this.selectedDate);
      this.unit = unit;
    },
    customOpenDateSelector() {
      this.isCustomOpen = !this.isCustomOpen;
    },
    toggleWeek() {
      this.selectedDate.start = moment()
        .startOf("isoWeek")
        .toDate();
      this.selectedDate.end = moment()
        .endOf("isoWeek")
        .toDate();

      this.onChangeDate("days");
      this.closeDropdown();
    },
    toggleMonth() {
      // this.selectedDate.start = new Date(
      //   today.getFullYear(),
      //   today.getMonth(),
      //   1
      // );
      // this.selectedDate.end = new Date(
      //   today.getFullYear(),
      //   today.getMonth() + 1,
      //   0
      // );
      this.selectedDate.start = moment()
        .startOf("month")
        .toDate();
      this.selectedDate.end = moment()
        .endOf("month")
        .toDate();

      this.onChangeDate("months");
      this.closeDropdown();
    },
    toggleLastMonth() {
      this.selectedDate.start = moment()
        .subtract(1, "months")
        .startOf("month")
        .toDate();
      this.selectedDate.end = moment()
        .subtract(1, "months")
        .endOf("month")
        .toDate();

      this.onChangeDate("months");
      this.closeDropdown();
    },
    toggleLastSevenDays() {
      this.selectedDate.start = moment()
        .subtract(6, "days")
        .toDate();
      this.selectedDate.end = moment().toDate();

      this.onChangeDate("days");
      this.closeDropdown();
    },
    toggleLastThirtyDays() {
      this.selectedDate.start = moment()
        .subtract(29, "days")
        .toDate();
      this.selectedDate.end = moment().toDate();

      this.onChangeDate("days");
      this.closeDropdown();
    },
    toggleLastNinetyDays() {
      this.selectedDate.start = moment()
        .subtract(89, "days")
        .toDate();
      this.selectedDate.end = moment().toDate();

      this.onChangeDate("days");
      this.closeDropdown();
    },
    toggleLastWeek() {
      this.selectedDate.start = moment()
        .subtract(1, "weeks")
        .startOf("isoWeek")
        .toDate();
      this.selectedDate.end = moment()
        .subtract(1, "weeks")
        .endOf("isoWeek")
        .toDate();

      this.onChangeDate("days");
      this.closeDropdown();
    },
    toggleLastYear() {
      this.selectedDate.start = moment()
        .subtract(1, "years")
        .startOf("year")
        .toDate();
      this.selectedDate.end = moment()
        .subtract(1, "years")
        .endOf("year")
        .toDate();

      this.onChangeDate("years");
      this.closeDropdown();
    },
    toggleYear() {
      // this.selectedDate.start = new Date(today.getFullYear(), 0, 1);
      // this.selectedDate.end = new Date(today.getFullYear(), 11, 31);
      this.selectedDate.start = moment()
        .startOf("year")
        .toDate();
      this.selectedDate.end = moment()
        .endOf("year")
        .toDate();

      this.onChangeDate("years");
      this.closeDropdown();
    },
    closeDropdown() {
      this.dropdownCustom = false;
    }
  }
};
</script>

<style scoped>
.dropdown-sp {
  width: 400px;
  /* z-index: -100; */
}
.margin-container {
  margin-bottom: 0.5rem;
}
/* .b-background {
} */
/* .btn-header {
  max-width: 120px;
} */
@media (max-width: 580px) {
  .dropdown-sp {
    width: 300px;
  }
  .btn-header {
    margin-bottom: 0.5rem;
  }
  .margin-container {
    margin-bottom: 0;
  }
  .btn-header {
    max-width: 120px;
  }
  .container-button {
    /* display: flex;
    flex-wrap: wrap; */
    max-width: 130px;
  }
  .b-background {
    height: 36px;
  }
  .b-background-drop {
    padding-top: 7px !important;
    padding-bottom: 7px !important;
  }
}
@media (max-width: 420px) {
  .btn-header {
    padding-left: 6px;
    padding-right: 6px;
    font-size: 11px;
  }
  .padding-sm {
    padding-left: 10px;
    padding-right: 10px;
  }

  .margin-sm {
    margin: 5px;
  }
  .b-background {
    height: 35px;
  }
}
</style>
